import { isDev, getWordings, shuffleArray, makeParagraphs, clone, normalize, padNumber, toLocale, inIframe } from 'global/js/apps.js'
import AppButton from 'global/components/AppButton'
import Scoreboard from '../components/Scoreboard'
import Neon from '../components/Neon'
import Nightsky from '../components/NightSky'
require('iframe-resizer/js/iframeResizer.contentWindow.min.js')

export default {
	name: 'Appli',
	components: { AppButton, Scoreboard, Neon, Nightsky },
	data: function() {
		return {
			isDev: isDev(),
			mobile: false,
			ready: false,
			innerWidth: window.innerWidth,
			duration: 0,
			nbQuestions: 0,
			activeScreenIdx: 1,
			activeQuestionIdx: 1,
			activeAnswer: '',
			score: 0,
			remainingSeconds: 0,
			timer: null,
			screens: [],
			wordings: {},
			tip: '',
			tipTimer: null,
			hasSkipped: false,
			showScoreboard: false,
			scoreSent: false,
			scoreChanging: false,
			fluoColors: [
				'#f91be8',
				'#ffc800',
				'#36f32a',
				'#28e9f3',
				'#e8262f',
				'#ffffff',
			],
			activeColors: [],
			breakpoints: {
				mobile: 600,
			},
			raw: {
				screens: []
			},
		}
	},
	created() {
		if (window.innerWidth <= this.breakpoints.mobile) this.mobile = true
		if (inIframe())  {
			let $iframe = parent.document.querySelector('iframe[src*="/apps/"]')
			if (this.isDev) $iframe = parent.document.querySelector('iframe')
			$iframe.style.minHeight = 'calc(100vh - 45px)'
			$iframe.style.marginTop = this.mobile ? '0px' : '-6px'
		}
		let url = this.store.dzServerEditorial + this.store.dzPath.replace('/','-') + '.json'
		if (this.isDev) {
			console.log('Getting editorial data:')
			console.log(url)
		}
		fetch(url, {cache: 'no-store'})
		.then(response => response.json())
		.then(notion => {                
			if (this.isDev) console.log(notion)
			this.raw.screens = notion.items
			this.wordings = getWordings(notion.config)
			this.duration = parseInt(notion.config.duration)
			this.nbQuestions = parseInt(notion.config.nb_questions)
			this.startGame('init')
			this.finishInit()
		})
	},
	computed: {
		scoreTxt: function() {
			return padNumber(this.score, 6)
		},
		activeScreen: function() {
			let screen = this.screens.find(s => s.order == this.activeScreenIdx)

			return screen
		},
		activeQuestion: function() {
			let question = this.activeScreen.questions[this.activeQuestionIdx-1]

			return question
		},
		activeAnswerSimilarity: function() {
			return this.checkSimilarity(this.activeAnswerRefined, this.correctAnswerRefined)
		},
		activeAnswerIsCorrect: function() {
			/*
			if (this.isDev) {
				console.log(this.activeAnswerRefined)
				console.log(this.correctAnswerRefined)
			}
			*/
			return this.activeAnswerRefined === this.correctAnswerRefined
		},
		activeScreenIsTransition: function() {
			if (!this.ready) return false
			return !this.activeScreen.questions.length
		},
		remainingTime: function() {
			return new Date(this.remainingSeconds * 1000).toISOString().substr(14, 5)
		},
		activeAnswerSimilarityMessage: function() {
			if (this.activeAnswerSimilarity < .4) return 'On y est pas du tout, là…'
			if (this.activeAnswerSimilarity < .6) return 'On s’approche, mais on est encore loin'
			if (this.activeAnswerSimilarity < .9) return 'Ça chauffe, ça chauffe…'
			return 'Ça BRÛLE, vous y êtes presque !'
		},
		activeAnswerRefined: function() {
			return this.cleanText(this.activeAnswer)
		},
		correctAnswerRefined: function() {
			return this.cleanText(this.activeQuestion.answer)
		},
		allQuestions: function() {
			return this.raw.screens.reduce((acc, screen) => {
				let questions = []
				screen.questions.map(question => {
					questions.push({
						id: question.id,
						name: question.name,
						points: screen.points,
					})
				})
				return acc.concat(questions)
			}, [])
		},
		shaking: function() {
			return this.remainingSeconds < 10 && this.remainingSeconds >= 1 && parseInt(this.remainingSeconds / 2) === this.remainingSeconds / 2
		}
	},
	methods: {
		cleanText: function(text) {
			return normalize(text.toLowerCase().trim(), false, ' ').replace('  ',' ')
		},
		changeScore: function(diff, speed=150) {
			this.scoreChanging = true
			let target = this.score + diff
			let increment = Math.trunc(diff / speed)
			if (diff >= 0 && increment == 0) increment = 1
			if (diff < 0 && increment == 0) increment = -1
			const updateCount = () => {
				if ((diff >= 0 && this.score < target) || (diff < 0 && this.score > target)) {
					this.score += increment
					setTimeout(updateCount, 1)
				} else {
					this.score = target
					this.scoreChanging = false
				}
			}
			updateCount()
		},
		pickColors: function() {
			let colors = shuffleArray(clone(this.fluoColors))
			this.activeColors = [colors[0], colors[1]]
		},
		startGame: function(origin) {
			this.$ga.event('click/touch', 'start-game')
			this.$ga.event('click/touch', 'start-game-' + origin)
			this.score = 0
			this.remainingSeconds = this.duration

			/*
			if (this.isDev) this.remainingSeconds = 15
			if (this.isDev) this.nbQuestions = 1
			if (this.isDev) this.score = 10000
			*/

			this.scoreSent = false
			this.screens = this.prepareScreens(this.raw.screens)
			this.activeAnswer = ''
			if (origin == 'init') this.activeScreenIdx = 1
			if (origin == 'again') this.activeScreenIdx = 2; this.activeQuestionIdx = 1; this.showScoreboard = false
			this.pickColors()

		},
		prepareScreens: function(screens) {
			screens = clone(makeParagraphs(screens, ['message', 'tip']))

			// Set time in intro message
			let intro = screens.find(s => s.name == 'intro')
			intro.message = intro.message.replace('{x}', toLocale(this.remainingSeconds))
			if (this.mobile) intro.message ='<p>' + intro.message.replace(/<p>|<\/p>/g,' ') + '</p>'

			let unpicked = []
			screens.forEach(screen => {	

				// Randomly select x questions and set questions for bonus screen
				let screenQuestions = shuffleArray(screen.questions)
				unpicked = unpicked.concat(screenQuestions.slice(this.nbQuestions))
				screen.questions = screenQuestions.slice(0, this.nbQuestions)
				if (screen.name == 'bonus') screen.questions = shuffleArray(unpicked)
			})

			return screens
		},
		setTip: function(text, delay=4000) {
			clearTimeout(this.tipTimer)
			this.tip += text
			if (this.mobile) this.tip = this.tip.replace(/<p>|<\/p>/g,' ')
			if (this.mobile) this.tip += '<br>'
			let $this = this
			this.tipTimer = setTimeout(() => {
				$this.tip = ''
			}, delay)	
		},
		nextQuestion: function(fate) {
			if (fate == 'correct' && this.activeScreen.name != 'bonus') this.changeScore(this.activeScreen.points)
			if (fate == 'correct' && this.activeScreen.name == 'bonus') {
				let thisQuestion = this.allQuestions.find(q => q.id == this.activeQuestion.id)
				this.changeScore(thisQuestion.points)
			}
			if (fate == 'skip') {
				this.changeScore(0 - this.activeScreen.penalty)
				this.setTip('<p>La réponse était&nbsp;: ' + this.activeScreen.questions[this.activeQuestionIdx-1].answer + '</p>')
				if (!this.hasSkipped && this.activeScreen.penalty > 0) {
					this.setTip('<p>Attention, à chaque fois que vous passez un sigle, <br>votre score diminue…</p>')
				}
				this.hasSkipped = true
			}
			if (this.activeQuestionIdx < this.activeScreen.questions.length) {
				this.activeQuestionIdx += 1 
				this.$nextTick(() => {
					this.$refs.textbox.focus()
				})
			} else {
				this.activeQuestionIdx = 1
				this.activeScreenIdx += 1
			}	
			this.activeAnswer = ''
			this.pickColors()
		},
		nextScreen: function() {
			if (this.activeScreenIdx < this.screens.length) {
				this.activeScreenIdx += 1
				this.showScoreboard = false
				this.activeAnswer = ''
				this.setTip(this.activeScreen.tip)
				this.pickColors()
			} else {
				this.startGame('again')
			}
			this.$nextTick(() => {
				if (!this.activeScreenIsTransition) {				
					this.$refs.textbox.focus()
				}
			})
		},
		finishInit: function() {
			this.ready = true
			this.$nextTick(() => {		
				this.$refs.focusEnd.addEventListener('focus', () => {
					let tabables = document.querySelectorAll('[tabindex]')
					if (tabables.length > 1) tabables[1].focus()
				})
				this.$refs.focusStart.addEventListener('focus', () => {
					let tabables = document.querySelectorAll('[tabindex]')
					if (tabables.length > 1) tabables[tabables.length - 2].focus()
				})
			})
		},
		startTimer: function() {
			this.timer = setInterval(() => {
				this.remainingSeconds -= 1
			}, 1000 )
		},
		checkSimilarity: function(s1, s2) {
			const editDistance = (s1, s2) => {
				s1 = s1.toLowerCase();
				s2 = s2.toLowerCase();

				let costs = new Array();
				for (let i = 0; i <= s1.length; i++) {
					let lastValue = i;
					for (let j = 0; j <= s2.length; j++) {
						if (i == 0)
							costs[j] = j;
						else {
							if (j > 0) {
								let newValue = costs[j - 1];
								if (s1.charAt(i - 1) != s2.charAt(j - 1))
									newValue = Math.min(Math.min(newValue, lastValue),
										costs[j]) + 1;
								costs[j - 1] = lastValue;
								lastValue = newValue;
							}
						}
					}
					if (i > 0)
						costs[s2.length] = lastValue;
				}
				return costs[s2.length];
			}
			let longer = s1;
			let shorter = s2;
			if (s1.length < s2.length) {
				longer = s2;
				shorter = s1;
			}
			let longerLength = longer.length;
			if (longerLength == 0) {
				return 1.0;
			}
			return (longerLength - editDistance(longer, shorter)) / parseFloat(longerLength);
		}
	},
	watch: {
		activeScreenIsTransition: function(value) {
			value ? clearInterval(this.timer) : this.startTimer()
		},
		remainingSeconds: function(time) {
			if (time <= 0) {
				this.activeScreenIdx = this.screens.find(s => s.name == 'outro').order
				this.showScoreboard = true
				clearInterval(this.timer)
			} 
		}
	}
}